<template>
    <div class="main">
        <a-card style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Poultry Breeds</h3>
                <!-- <div>
                <a-form-model
                    ref="loginForm"
                    :model="form"
                    :rules="rules"
                >
                    <a-form-model-item>
                        <a-input v-model="searchText" placeholder="search for anything">
                            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                </a-form-model>

            </div> -->
                <!-- <div>
                <a-input-search placeholder="Search by product name" style="width: 219px" @search="onSearch" />
            </div> -->
                <div style="display:flex; justify-content: space-around;">
                    <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                 Replenish Low Stock
                 <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                </a-button> -->


                    <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->

                    <a-button @click="showBreedModal"
                        style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;">
                        <a-icon type="plus" /> Add New Breed
                    </a-button>
                    <!-- 
                <a-button :loading="exportLoading" @click="exportExcell" style="border-raduis:6px; background: #fff;color:#0F3659" icon="upload" >
                 Export
                </a-button>  -->
                </div>

            </div>
            <div>
                <a-table :columns="columns" :data-source="tableData" :pagination="pagination" :loading='tableLoading'
                    :scroll="{ x: 1500, y: 600 }" @change="handleTableChange" class="tableStyle">

                    <SettingIcon slot="filterIcon" slot-scope="" />


                    <span slot="actions" slot-scope="data">
                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">

                                <a-menu-item>
                                    <a @click="showEditDetails(data)">Edit Breed?</a>
                                </a-menu-item>
                                <!-- <a-menu-item>
                                    <a @click="showUploadImage(data)">Upload Product Image?</a>
                                </a-menu-item> -->
                                <!-- <a-menu-item>
                                    <a @click="showMoreDetailsModal(data)">More Details?</a>
                                </a-menu-item> -->
                                <!-- <a-menu-item>
                                    <a @click="showPriceModal(data)">Set Price?</a>
                                </a-menu-item> -->
                                <!-- <a-menu-item>
                                    <a href="javascript:;">View Product Details</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;">View Inventory Details</a>
                                </a-menu-item> -->
                            </a-menu>
                        </a-dropdown>
                    </span>

                    <template slot="thumb" slot-scope="">
                        <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png' />
                    </template>

                    <template slot="templateStatusLabel" slot-scope="data">
                        <status-component :status="data"></status-component>
                    </template>
                </a-table>

            </div>
        </a-card>

        <a-modal class="modalStyle" :visible="addBreedVisible" :footer="null" width="600px"
            @cancel="closeBreedModal">
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;">Add Breed</p>
            <div style="display:flex;justify-content: center;">
                <a-form-model ref="addBreedRef" :model="addBreedModel" :rules="rules">
                    <a-row>
                        <a-col :span="24" :offset="0">
                            <a-form-model-item label="Name" ref="name" prop="name">
                                <a-input class="" v-model="addBreedModel.name" />
                            </a-form-model-item>
                        </a-col>
                       
                    </a-row>
                    <a-row style="margin-top:53px;">
                        <a-col :span="24" :offset="0">
                            <a-form-model-item label="Notes" ref="notes" prop="notes">
                                <a-textarea v-model="addBreedModel.notes" placeholder="Enter notes...."
                      :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>

            </div>

          
            <div style="display: flex;justify-content: center;padding-top:90px">
                <a-button :loading="loading" @click="handleAddBreedTemplate" style="background: #418a49;color:#fff;border-radius:5px;">
                    Add Breed
                </a-button>
            </div>
        </a-modal>

        <a-modal class="modalStyle" :visible="editBreedVisible" :footer="null" width="600px"
            @cancel="closeEditBreedModal">
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;">Edit Breed</p>
            <div style="display:flex;justify-content: center;">
                <a-form-model ref="editBreedRef" :model="editBreedModel" :rules="rules">
                    <a-row>
                        <a-col :span="24" :offset="0">
                            <a-form-model-item label="Name" ref="name" prop="name">
                                <a-input class="" v-model="editBreedModel.name" />
                            </a-form-model-item>
                        </a-col>
                       
                    </a-row>
                    <a-row style="margin-top:53px;">
                        <a-col :span="24" :offset="0">
                            <a-form-model-item label="Notes" ref="notes" prop="notes">
                                <a-textarea v-model="editBreedModel.notes" placeholder="Enter notes...."
                      :auto-size="{ minRows: 3, maxRows: 5 }" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>

            </div>

          
            <div style="display: flex;justify-content: center;padding-top:90px">
                <a-button :loading="loading" @click="handleEditBreedTemplate" style="background: #418a49;color:#fff;border-radius:5px;">
                    Edit Breed
                </a-button>
            </div>
        </a-modal>

    </div>
</template>



<script>
import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";
import moment from 'moment';
import StatusComponent from "@/components/shared-components/StatusComponent.vue";
// import SettingSvg from '../../assets/img/settings.svg';
// import _ from 'lodash';
// import reqwest from 'reqwest';
import SettingIcon from '../common/components/SettingIcon.vue'


const columns = [
    {
        title: 'Breed ID',
        key: 'id',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        width: 150,
    },
    {
        title: 'Notes',
        key: 'notes',
        dataIndex: 'notes',
        width: 200,
    },
    {
        title: 'Created At',
        width: 200,
        dataIndex: 'createdAt',
    },
     {
        title: 'Actions',
        key: 'actions',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'actions' },
    },
    
];


export default {
    name: 'Breeds',
    components: {
        SettingIcon,
        StatusComponent
    },
    data() {
        return {
            data: [],
            columns,
            pagination: {
                pageSize: 20,
                current: 1
            },
            addBreedVisible: false,
            editBreedVisible: false,
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            tableData: [],
            tableLoading: false,
            loading: false,
            exportLoading: false,
            addBreedModel: {
                name: '',
                notes: ''
            },
            editBreedModel: {
                name: '',
                notes: ''
            },
            selectedBreed: {},
            rules: {
                name: [
                    { required: true, message: 'Please enter name', trigger: 'change' },

                ],
              
            }
        };
    },
    computed: {
        ...mapGetters(['getPagination']),
        sortedData() {
            // console.log("sorted | ", _.sortBy(this.data, 'createdAt'))
            // return _.orderBy(this.data, 'createdAt','desc');
            return this.data;
        }
    },
    methods: {
        ...mapActions([ 'addVaccineTemplate', 'setCatalogInfo', 'setProductPrice', 'uploadProductImage', 'finalCategoryManufacturerSupplierList', 'setProductStatus', 'setPaginationInfo', 'setPreviewInfo']),
        handleSubmit() {
            // console.log(this.formInline);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination before change | ", this.pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            // console.log("pagination after change | ", this.pagination);
            this.setPaginationInfo(this.pagination)
            this.tableLoading = false
        },

        showBreedModal() {
            this.addBreedVisible = true;
        },
        closeBreedModal() {
            this.addBreedVisible = false;
        },
        closeEditBreedModal() {
            this.editBreedVisible = false;
        },
        showAddProductPage() {
            this.$router.push('/new-product').catch(() => { });
        },
        showAddStockPage() {
            this.$router.push('/add-stock').catch(() => { });
        },
        showEditDetails(data) {
            this.selectedBreed = data;
            this.editBreedModel.name = data.name;
            this.editBreedModel.notes = data.notes;
            this.editBreedVisible = true;
        },
        showPriceModal(data) {
            this.setPrice.sellingPrice = data.action.sellingPrice
            this.setPrice.purchasePrice = data.action.purchasePrice
            this.isPriceVisible = true
            this.product = data
        },

        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        exportExcell() {
            this.exportLoading = true
            const dataToExport = [
                [
                    "Product ID",
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Quantity",
                    "Commission",
                    "Cost Price(Ksh)",
                    "Selling Price",
                    "Profit Margin"
                ],
            ];

            this.data.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.productName,
                    v.category,
                    v.supplier,
                    v.manufacturer,
                    v.quantity,
                    v.commission,
                    v.costPrice,
                    v.price,
                    v.profitMargin
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Product-Catalog-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")

        },
        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        showLowStockPage() {
            let distributionData = this.balLessThan20.map(product => ({
                key: this.randomString(10),
                id: product.key,
                name: product.productName ? product.productName : "N/A",
                category: product.category ? product.category : "N/A",
                quantity: product.quantity ? product.quantity.toString() : '0',
                unitPrice: product.costPrice ? product.costPrice.toString() : "0",
                lineTotal: parseInt(product.quantity) * parseInt(product.costPrice),
                extra_data: product.action
            }))

            let previewData = {
                discount: '',
                deliveryDate: "",
                supplierName: "",
                supplierId: "",
                distributionCentreName: '',
                distributionCentreId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: '',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distributionData,
                tableData: distributionData
            }
            //   console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/quick-action-receipt').catch(() => { });
        },

        handleAddBreedTemplate() {
            this.$refs.addBreedRef.validate(async valid => {
                if (valid) {
                    this.loading = true;

                    const request = {
                        name: this.addBreedModel.name,
                        notes: this.addBreedModel.notes
                    }

                    const response = await this.$store.dispatch("breeds/addBreed", request);

                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("New Breed Created Successfully")
                        this.getBreeds();
                        this.addBreedModel = {
                            name: '',
                            notes: ''
                        }
                        this.addBreedVisible = false;
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        
        handleEditBreedTemplate() {
            this.$refs.editBreedRef.validate(async valid => {
                if (valid) {
                    this.loading = true;

                    const request = {
                        id: this.selectedBreed.id,
                        data: {
                            name: this.editBreedModel.name,
                            notes: this.editBreedModel.notes
                        }
                    }

                    const response = await this.$store.dispatch("breeds/editBreed", request);

                    this.loading = false;
                    if (response.status === 200) {
                        this.showSuccessAlert("Breed Updated Successfully")
                        this.getBreeds();
                        this.editBreedVisible = false;
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        async getBreeds() {
            this.tableLoading = true;
            const response = await this.$store.dispatch('breeds/getBreeds');
            this.tableLoading = false;
            this.setTableData(response.data)
        },

        setTableData(data) {
            this.tableData = data.data.map(breed => {
                return {
                    ...breed,
                    key: breed.id,
                    createdAt: moment(breed.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                };
            });
        }

    },
    created() {
        this.getBreeds();
    },
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.ant-form-item {
    font-size: 14px;
    height: 38px;
    width: 294px;
    border-radius: 5px;
}

.ant-form-item>>>span {
    text-align: center;
}

.ant-btn {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;

    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 38px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;

}

.ant-btn:hover,
.ant-btn:focus {
    color: #418a49;
    background-color: #fff;
    border-color: #418a49;
}

/* .ant-input:focus,
.ant-input:hover {
    border-color: #418a49;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
} */

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.actionLinks {
    color: #777777;
}

.rightSideinputText {
    width: 100%;
    height: 50px;
    border-radius: 5px;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
    width: 100%
}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}
</style>
